import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSupplierContext } from "../../../context/SupplierContext";
import "./updateSupplier.css";

const UpdateSupplier = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    id: "",
    full_name: "",
    phone: "",
    balance: 0,
    description: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const { suppliers, isFetching, updateSupplier } = useSupplierContext();

  useEffect(() => {
    if (id && suppliers.length > 0 && !isFetching) {
      const supplier = suppliers.find((s) => s.id === parseInt(id));
      if (supplier) {
        setSelectedSupplier(supplier);
        setFormData({
          id: supplier.id,
          full_name: supplier.full_name,
          phone: supplier.phone,
          balance: supplier.balance,
          description: supplier.description || "",
        });
        if (selectedSupplier?.id !== supplier.id) {
          setError("");
          setMessage("");
        }
      } else {
        setError("المورد غير موجود");
        setMessage("");
      }
    }
  }, [id, suppliers, isFetching]);

  const handleSelectSupplier = (supplier) => {
    navigate(`/update-supplier/${supplier.id}`);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!formData.id) return setError("يرجى اختيار مورد للتحديث");
    if (!formData.full_name.trim()) return setError("الاسم الكامل مطلوب");
    if (!formData.phone.trim()) return setError("رقم الهاتف مطلوب");

    setIsLoading(true);

    const result = await updateSupplier(formData);

    setIsLoading(false);

    if (result.success) {
      setMessage(result.message);
    } else {
      setError(result.message || "حدث خطأ أثناء التحديث");
    }
  };

  return (
    <div className="supplier-page">
      <div className="supplier-list">
        <h2>🏢 الموردون الحاليون</h2>
        {isFetching ? (
          <p className="loading-text">جارٍ التحميل...</p>
        ) : suppliers.length === 0 ? (
          <p className="no-suppliers">لا يوجد موردون بعد</p>
        ) : (
          <ul>
            {suppliers.map((supplier) => (
              <li
                key={supplier.id}
                onClick={() => handleSelectSupplier(supplier)}
                className={
                  selectedSupplier?.id === supplier.id ? "selected" : ""
                }
              >
                <p>
                  الاسم: <strong>{supplier.full_name}</strong>
                </p>
                <p>
                  الهاتف: <span>{supplier.phone}</span>
                </p>
                <p>
                  الرصيد: <span>{supplier.balance} ₪</span>
                </p>
                {supplier.description && (
                  <p>
                    الوصف: <span>{supplier.description}</span>
                  </p>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="card-parent">
        <div className="new-supplier-card">
          <div className="new-supplier-header">
            <h1 className="new-supplier-title">تحديث مورد</h1>
            <p className="new-supplier-subtitle">
              اختر مورد من القائمة ثم عدل معلوماته واضغط على زر التحديث
            </p>
          </div>

          <form className="new-supplier-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="full_name" className="form-label">
                الاسم الكامل <span className="required">*</span>
              </label>
              <input
                type="text"
                id="full_name"
                name="full_name"
                className="form-input"
                placeholder="أدخل الاسم الكامل"
                value={formData.full_name}
                onChange={handleChange}
                required
                disabled={!selectedSupplier}
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone" className="form-label">
                رقم الهاتف <span className="required">*</span>
              </label>
              <input
                type="text"
                id="phone"
                name="phone"
                className="form-input"
                placeholder="أدخل رقم الهاتف"
                value={formData.phone}
                onChange={handleChange}
                required
                disabled={!selectedSupplier}
              />
            </div>

            <div className="form-group">
              <label htmlFor="balance" className="form-label">
                الرصيد الحالي
              </label>
              <input
                type="text"
                id="balance"
                name="balance"
                className="form-input"
                placeholder="0"
                value={formData.balance}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.-]/g, "");
                  handleChange({ target: { name: "balance", value } });
                }}
                disabled={!selectedSupplier}
              />
            </div>

            <div className="form-group">
              <label htmlFor="description" className="form-label">
                الوصف
              </label>
              <textarea
                id="description"
                name="description"
                className="form-input"
                placeholder="أدخل وصفاً اختياريًا"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                disabled={!selectedSupplier}
              ></textarea>
            </div>

            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}

            <button
              type="submit"
              className={`submit-button ${isLoading ? "loading" : ""}`}
              disabled={isLoading || !selectedSupplier}
            >
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                "تحديث المورد"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateSupplier;
